import { render, staticRenderFns } from "./VoyageDescription.vue?vue&type=template&id=70c9f89d&scoped=true&"
import script from "./VoyageDescription.vue?vue&type=script&lang=js&"
export * from "./VoyageDescription.vue?vue&type=script&lang=js&"
import style0 from "./VoyageDescription.vue?vue&type=style&index=0&id=70c9f89d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c9f89d",
  null
  
)

export default component.exports